import React, { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { fetchUsers } from "../../../redux/api/admin.api";
import { TableActions } from "../../../components/tables/tableContext/TableContext";
import TableWidget from "../../../components/tables/TableWidget";
import UsersActionButton from "./components/TableActionsButtonsComponents/UsersActionButton";
import {
  getUsersTableData,
  usersTableHeader,
} from "./components/tableConfigs/usersTableConfig";
import FormHeader from "../../../components/misc/FormHeader";
import { adminRoutes } from "../../../router/routesConstants";

function Users() {
  const dispatch = useAppDispatch();

  const {
    admin: {
      users: {
        data: { data: users, total },
        isLoading,
      },
    },
  } = useAppSelector((state) => ({
    admin: state.admin,
  }));

  const handleTableActions = useCallback(
    (action: TableActions) => {
      dispatch(
        fetchUsers({
          page: action.tablePagination.page,
          perPage: action.tablePagination.rowsPerPage,
          username: action.tableSearch.username,
          firstName: action.tableSearch.firstName,
          secondName: action.tableSearch.secondName,
        }),
      );
    },
    [dispatch],
  );

  return (
    <TableWidget
      CustomHeaderComponent={() => (
        <FormHeader
          title="Utilizatori definiti in sistem"
          buttonRoute={`/${adminRoutes.users}/${adminRoutes.createUser}`}
          buttonIcon="ADD"
          buttonLabel="Creeaza utilizator"
          tooltipTitle="Creare utilizator"
        />
      )}
      tableHeaderData={usersTableHeader}
      tableItemsData={getUsersTableData(users)}
      totalItems={total}
      borderedRow
      tableLoading={isLoading}
      ActionButtonsComponent={(props: any) => <UsersActionButton {...props} />}
      handleTableActions={handleTableActions}
    />
  );
}

export default Users;
